import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { MusicPlayerProvider } from "./context/MusicPlayerContext";
import Layout from "./components/Layout";
import Home from "./Page/Home";
import Search from "./Page/Search";
import MusicLibrary from "./Page/Library";
import Settings from "./Page/Setting";
import Favourite from "./Page/Favourite";
import Chat from "./Page/Chat";
import Login from "./Page/Login";
import CreatePlaylist from "./Page/CreatePlaylist";
import LikedSongs from "./Page/LikedSongs";
import Premium from "./Page/Premium";
import PaymentStatus from "./Page/PaymentStatus";
import UserProfile from "./Page/UserProfile";
import PrivacyPolicy from "./Page/PrivacyPolicy";
import CancellationRefunds from "./Page/CancellationRefunds";
import Shipping from "./Page/Shipping";
import TermsConditions from "./Page/TermsConditions";
import Contact from "./Page/Contact";
import Artists from "./Page/Artists";
import SubscriptionTeaser from "./Page/SubscriptionTeaser";
import Landing from "./Page/Landing";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import MusicPlayerDemo from "./components/MusicPlayerDemo";
import ScrollToTop from "./components/ScrollToTop";
import SubscriptionCheck from "./components/SubscriptionCheck";


export default function App() {
  return (
    <MusicPlayerProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
        {/* Public routes - No authentication required */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/home" element={<ProtectedRoute><SubscriptionCheck><Layout><Home /></Layout></SubscriptionCheck></ProtectedRoute>} />
        <Route path="/search" element={<ProtectedRoute><SubscriptionCheck><Layout><Search /></Layout></SubscriptionCheck></ProtectedRoute>} />
        <Route path="/library" element={<ProtectedRoute><SubscriptionCheck><Layout><MusicLibrary /></Layout></SubscriptionCheck></ProtectedRoute>} />
        <Route path="/artists" element={<ProtectedRoute><SubscriptionCheck><Layout><Artists /></Layout></SubscriptionCheck></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><SubscriptionCheck><Layout><Settings /></Layout></SubscriptionCheck></ProtectedRoute>} />
        <Route path="/user-profile" element={<ProtectedRoute><SubscriptionCheck><Layout><UserProfile /></Layout></SubscriptionCheck></ProtectedRoute>} />
        <Route path="/favourite" element={<ProtectedRoute><SubscriptionCheck><Layout><Favourite /></Layout></SubscriptionCheck></ProtectedRoute>} />
        <Route path="/chat" element={<ProtectedRoute><SubscriptionCheck><Layout><Chat /></Layout></SubscriptionCheck></ProtectedRoute>} />
        <Route path="/create-playlist" element={<ProtectedRoute><SubscriptionCheck><Layout><CreatePlaylist /></Layout></SubscriptionCheck></ProtectedRoute>} />
        <Route path="/liked-songs" element={<ProtectedRoute><SubscriptionCheck><Layout><LikedSongs /></Layout></SubscriptionCheck></ProtectedRoute>} />
        <Route path="/premium" element={<ProtectedRoute><Layout><Premium /></Layout></ProtectedRoute>} />
        <Route path="/payment-status" element={<ProtectedRoute><Layout><PaymentStatus /></Layout></ProtectedRoute>} />
        <Route path="/privacy-policy" element={<Layout><PrivacyPolicy /></Layout>} />
        <Route path="/cancellation-refunds" element={<Layout><CancellationRefunds /></Layout>} />
        <Route path="/shipping" element={<Layout><Shipping /></Layout>} />
        <Route path="/terms-conditions" element={<Layout><TermsConditions /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/music-player-demo" element={<ProtectedRoute><Layout><MusicPlayerDemo /></Layout></ProtectedRoute>} />
        <Route path="/subscription-teaser" element={<ProtectedRoute><Layout><SubscriptionTeaser /></Layout></ProtectedRoute>} />
        {/* Fallback route */}
        <Route path="*" element={<ProtectedRoute><SubscriptionCheck><Layout><Home /></Layout></SubscriptionCheck></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </MusicPlayerProvider>
  );
}